import _ from 'underscore';
import { PerformanceMetricBaseColumn, PhonePerformanceMetricBaseColumn } from './performance-metric-base-column';
import { ColumnClicksWithFluctuation, ColumnImpressionsWithFluctuation, ColumnSpendWithFluctuation } from './fluctuations/performance-columns-with-fluctuation';
/**
 * Column Clicks.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnClicks extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId }) {
    super({
      name: 'Clicks',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * Column Impressions.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnImpressions extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_Impr' }) {
    super({
      name: 'Impressions',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * Column CTR.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnCTR extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId }) {
    super({
      name: 'CTR',
      format: 'percentage-value',
      i18n,
      helpId,
    });
  }
}

/**
 * Column AverageCPC.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAverageCPC extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_AvgCPC' }) {
    super({
      name: 'AverageCPC',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column AveragePosition.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAveragePosition extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_AvgPosition' }) {
    super({
      name: 'AveragePosition',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column AverageCPM.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAverageCPM extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_AvgCPM' }) {
    super({
      name: 'AverageCPM',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column VideoViews.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnVideoViews extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_VideoViews' }) {
    super({
      name: 'VideoViews',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * Column ViewThroughRate.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughRate extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_ViewThroughRate' }) {
    super({
      name: 'ViewThroughRate',
      format: 'percentage-value',
      i18n,
      helpId,
    });
  }
}

/**
 * Column AverageCPV.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAverageCPV extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_AverageCPV' }) {
    super({
      name: 'AverageCPV',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column TotalWatchTimeInMS.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnTotalWatchTimeInMS extends PerformanceMetricBaseColumn {
  // This helpId is not used in adgroup grid, for adgroup grid,
  // see /private/summary-tabs/packages/ad-groups-grid/src/grid-config.js
  constructor({ i18n, helpId = 'Page_CampaignGrids_TotalWatchTime' }) {
    super({
      name: 'TotalWatchTimeInMS',
      format: 'thousandth',
      i18n,
      helpId,
    });
  }
}

/**
 * Column AverageWatchTimePerImpression.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAverageWatchTimePerImpression extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_AverageWatchTimePerImpression' }) {
    super({
      name: 'AverageWatchTimePerImpression',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column AverageWatchTimePerVideoView.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAverageWatchTimePerVideoView extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_AverageWatchTimePerVideoView' }) {
    super({
      name: 'AverageWatchTimePerVideoView',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column VideoViewsAt25Percent.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnVideoViewsAt25Percent extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_VideoViewsAt25Percent' }) {
    super({
      name: 'VideoViewsAt25Percent',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * Column VideoViewsAt50Percent.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnVideoViewsAt50Percent extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_VideoViewsAt50Percent' }) {
    super({
      name: 'VideoViewsAt50Percent',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * Column VideoViewsAt75Percent.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnVideoViewsAt75Percent extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_VideoViewsAt75Percent' }) {
    super({
      name: 'VideoViewsAt75Percent',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * Column CompletedVideoViews.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnCompletedVideoViews extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_CompletedVideoViews' }) {
    super({
      name: 'CompletedVideoViews',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * Column VideoCompletionRate.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnVideoCompletionRate extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_VideoCompletionRate' }) {
    super({
      name: 'VideoCompletionRate',
      format: 'percentage-value',
      i18n,
      helpId,
    });
  }
}

/**
 * Column Spend.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnSpend extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId }) {
    super({
      name: 'Spend',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column Total spend.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnTotalSpend extends PhonePerformanceMetricBaseColumn {
  // it's put in performance columns in UI, but in metadata, it is phone performance metrics.
  constructor({ i18n }) {
    super({
      name: 'ClickAndPhoneSpend',
      format: 'decimal',
      i18n,
      helpId: null,
    });
  }
}

export class ColumnTopImpressionRate extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'TopImpressionRate',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_Reporting_Clarity_TopImpressionRate',
    });
  }
}

export class ColumnAbsoluteTopImpressionRate extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AbsoluteTopImpressionRate',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_Reporting_Clarity_AbsoluteTopImpressionRate',
    });
  }
}

export class ColumnCPS extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AverageCPS',
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_CampaignGrids_CostPerSale',
    });
  }
}

export class ColumnDownloads extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'Downloads',
      format: 'integer',
      i18n,
      helpId: 'pop_BA_AppAds_Downloads',
    });
  }
}

export class ColumnFirstLaunches extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'FirstLaunches',
      format: 'integer',
      i18n,
      helpId: 'pop_BA_AppAds_Installs',
    });
  }
}

export class ColumnPurchases extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'Purchases',
      format: 'integer',
      i18n,
      helpId: 'pop_BA_AppAds_InAppPurchase',
    });
  }
}

export class ColumnSubscriptions extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'Subscriptions',
      format: 'integer',
      i18n,
      helpId: 'pop_BA_AppAds_InAppSubscription',
    });
  }
}

export class ColumnPostClickDownloadRate extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'PostClickDownloadRate',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_AppAds_DownloadRate',
    });
  }
}

export class ColumnCostPerDownload extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'CostPerDownload',
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_AppAds_CostPerDownload',
    });
  }
}

export class ColumnPostClickFirstLaunchRate extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'PostClickFirstLaunchRate',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_AppAds_InstallRate',
    });
  }
}

export class ColumnCostPerFirstLaunch extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'CostPerFirstLaunch',
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_AppAds_CostPerInstall',
    });
  }
}

export class ColumnPostInstallPurchaseRate extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'PostInstallPurchaseRate',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_AppAds_PostInstallPurchase',
    });
  }
}

export class ColumnCostPerPurchase extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'CostPerPurchase',
      format: 'decimal',
      i18n,
      helpId: null,
    });
  }
}

export class ColumnPostInstallSubscriptionRate extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'PostInstallSubscriptionRate',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_AppAds_PostInstallSubscription',
    });
  }
}

export class ColumnCostPerSubscription extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'CostPerSubscription',
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_Reporting_Clarity_TopImpressionRate',
    });
  }
}

export const getPerformanceColumns = ({
  withFluctuations,
  IsVideoAdsPerfMetricsEnabled,
  isCPSEnabled,
  isAppCampaignNewCampaignGridColumnsEnabled,
} = {}) =>
  _.compact([
    withFluctuations ? ColumnClicksWithFluctuation : ColumnClicks,
    withFluctuations ? ColumnImpressionsWithFluctuation : ColumnImpressions,
    ColumnCTR,
    ColumnAverageCPC,
    withFluctuations ? ColumnSpendWithFluctuation : ColumnSpend,
    ColumnAveragePosition,
    ColumnAverageCPM,
    IsVideoAdsPerfMetricsEnabled && ColumnVideoViews,
    IsVideoAdsPerfMetricsEnabled && ColumnViewThroughRate,
    IsVideoAdsPerfMetricsEnabled && ColumnAverageCPV,
    IsVideoAdsPerfMetricsEnabled && ColumnTotalWatchTimeInMS,
    IsVideoAdsPerfMetricsEnabled && ColumnAverageWatchTimePerImpression,
    IsVideoAdsPerfMetricsEnabled && ColumnAverageWatchTimePerVideoView,
    IsVideoAdsPerfMetricsEnabled && ColumnVideoViewsAt25Percent,
    IsVideoAdsPerfMetricsEnabled && ColumnVideoViewsAt50Percent,
    IsVideoAdsPerfMetricsEnabled && ColumnVideoViewsAt75Percent,
    IsVideoAdsPerfMetricsEnabled && ColumnCompletedVideoViews,
    IsVideoAdsPerfMetricsEnabled && ColumnVideoCompletionRate,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnDownloads,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnFirstLaunches,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnPurchases,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnSubscriptions,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnPostClickDownloadRate,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnCostPerDownload,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnPostClickFirstLaunchRate,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnCostPerFirstLaunch,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnPostInstallPurchaseRate,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnCostPerPurchase,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnPostInstallSubscriptionRate,
    isAppCampaignNewCampaignGridColumnsEnabled && ColumnCostPerSubscription,
    isCPSEnabled && ColumnCPS,
    ColumnTotalSpend,
  ]);

/**
 * All performance columns without performance fluctuation insights or video
 * @type Class[]
 */
export const performanceColumns = getPerformanceColumns();
